import React from 'react';
import { t } from 'ttag';
import style from './modal.scss';

function Modal({ title, showNotice, content, visibility, closeModal }) {
    if (!visibility) {
        return null;
    }

    return (
        <div className={style.container}>
            <div className={style.overlay} onClick={(event) => closeModal(event)} />
            <div className={style.modal}>
                <header className={style.header}>
                    <h2 className={style.title}>
                        {title}
                    </h2>
                    <button
                        className={style.close}
                        onClick={(event) => closeModal(event)}
                    />
                </header>
                <main className={style.content}>
                    {showNotice ? <p className={style.notice}>{t`Mit Klick auf die Option können Sie zum entsprechenden Schritt springen und Ihre Auswahl ändern.`}</p> : ''}
                    <p>{content}</p>
                </main>
                <footer className={style.footer}>
                    <button
                        className={style.button__secondary}
                        onClick={(event) => closeModal(event)}
                    >
                        {t`Schließen`}
                    </button>
                </footer>
            </div>
        </div>
    );

}

export default Modal;
